<div class="TenFour-Order-View">
    <div class="row">
        <div class="col  mb-4">
            <div class="data-board">
                <div class="row">
                    <div class="col-6">
                        <table class="table  table-sm">
                            <tbody>
                            <tr>
                                <td>Leveringsmåde:</td>
                                <td><!-- @todo --></td>
                            </tr>
                            <tr>
                                <td>Leveringsbetingelser</td>
                                <td><!-- @todo --></td>
                            </tr>
                            <tr>
                                <td>Betalingsbetingelser</td>
                                <td>
                                    {{order.payment_agreement_days|json}} / {{order.payment_agreement_is_running_month|json}}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-6">
                        <table class="table  table-sm">
                            <tbody>
                                <tr>
                                    <td>Forfald:</td>
                                    <td><!-- @todo --></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <hr>

                <div class="text-right">
                    [KNAPPER] <!-- @todo -->
                </div>

                <div class="row">
                    <div class="col-4">
                        <table class="table  table-sm">
                            <tbody>
                                <tr>
                                    <td>Udskrives:</td>
                                    <td>
                                        <div class="form-check  d-inline  mx-2">
                                            <input class="form-check-input  inline-checkbox" type="radio" name="order-choice-print" id="order-choice-print-yes" value="1" checked>
                                            <label class="form-check-label" for="order-choice-print-yes">Ja</label>
                                        </div>
                                        <div class="form-check  d-inline">
                                            <input class="form-check-input  inline-checkbox" type="radio" name="order-choice-print" id="order-choice-print-no" value="0" checked>
                                            <label class="form-check-label" for="order-choice-print-no">Nej</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Hvornår:</td>
                                    <td>
                                        <div class="form-check  d-inline  mx-2">
                                            <input class="form-check-input  inline-checkbox" type="radio" name="order-choice-print" id="order-choice-print-yes" value="1" checked>
                                            <label class="form-check-label" for="order-choice-print-yes">Nu</label>
                                        </div>
                                        <div class="form-check  d-inline">
                                            <input class="form-check-input  inline-checkbox" type="radio" name="order-choice-print" id="order-choice-print-no" value="0" checked>
                                            <label class="form-check-label" for="order-choice-print-no">Senere</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Antal kopier:</td>
                                    <td>
                                        <select class="form-control  form-control-sm" name="" id="">
                                            <option value=""></option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Udskrivning:</td>
                                    <td>
                                        <select class="form-control  form-control-sm" name="" id="">
                                            <option value=""></option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Printer:</td>
                                    <td>
                                        <div class="form-check  d-inline  mx-2">
                                            <input class="form-check-input  inline-checkbox" type="radio" name="order-choice-printer-no" id="order-choice-printer-no-1" value="1" checked>
                                            <label class="form-check-label" for="order-choice-printer-no-1">1</label>
                                        </div>
                                        <div class="form-check  d-inline">
                                            <input class="form-check-input  inline-checkbox" type="radio" name="order-choice-printer-no" id="order-choice-printer-no-2" value="2" checked>
                                            <label class="form-check-label" for="order-choice-printer-no-2">2</label>
                                        </div>
                                        <div class="form-check  d-inline">
                                            <input class="form-check-input  inline-checkbox" type="radio" name="order-choice-printer-no" id="order-choice-printer-no-3" value="3" checked>
                                            <label class="form-check-label" for="order-choice-printer-no-3">3</label>
                                        </div>
                                        <div class="form-check  d-inline">
                                            <input class="form-check-input  inline-checkbox" type="radio" name="order-choice-printer-no" id="order-choice-printer-no-4" value="4" checked>
                                            <label class="form-check-label" for="order-choice-printer-no-4">4</label>
                                        </div>
                                        <div class="form-check  d-inline">
                                            <input class="form-check-input  inline-checkbox" type="radio" name="order-choice-printer-no" id="order-choice-printer-no-5" value="5" checked>
                                            <label class="form-check-label" for="order-choice-printer-no-5">5</label>
                                        </div>
                                        <div class="form-check  d-inline">
                                            <input class="form-check-input  inline-checkbox" type="radio" name="order-choice-printer-no" id="order-choice-printer-no-6" value="6" checked>
                                            <label class="form-check-label" for="order-choice-printer-no-6">6</label>
                                        </div>
                                        <div class="form-check  d-inline">
                                            <input class="form-check-input  inline-checkbox" type="radio" name="order-choice-printer-no" id="order-choice-printer-no-7" value="disk" checked>
                                            <label class="form-check-label" for="order-choice-printer-no-7">7</label>
                                        </div>
                                        <div class="form-check  d-inline">
                                            <input class="form-check-input  inline-checkbox" type="radio" name="order-choice-printer-no" id="order-choice-printer-no-disk" value="0" checked>
                                            <label class="form-check-label" for="order-choice-printer-no-disk">Disk</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Udskriv tilh. indkøb:</td> <!-- @todo what is this short for ? -->
                                    <td>
                                        <div class="form-check  d-inline  mx-2">
                                            <input class="form-check-input  inline-checkbox" type="radio" name="order-choice-print" id="order-choice-print-yes" value="1" checked>
                                            <label class="form-check-label" for="order-choice-print-yes">Nu</label>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-6">
                        <table class="table  table-sm">
                            <tbody>
                                <tr>
                                    <td>Ventekode:</td>
                                    <td>
                                        <select class="form-control  form-control-sm" name="" id="">
                                            <option value="">OK</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Dato for postering:</td><!-- @todo why is this changable ?! -->
                                    <td>
                                        <input class="form-control  form-control-sm" name="" id="">
                                    </td>
                                </tr>
                                <tr>
                                    <td>Forfald:</td><!-- Why, should be derived by the payment agreement... -->
                                    <td>
                                        <input class="form-control  form-control-sm" name="" id="">
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
